import { useState } from 'react';

import { useAuth } from '../../context/AuthContext';

export default function LoginView({ onSwitch, onSuccess }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login({ email, password });
      onSuccess();
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="auth-panel" onSubmit={handleSubmit} noValidate>
      <h2 className="auth-title">Welcome back</h2>
      <p className="auth-sub">Log in to your account</p>

      {error && <div className="auth-error">{error}</div>}

      <div className="field">
        <label htmlFor="login-email">Email</label>
        <input
          type="email"
          id="login-email"
          placeholder="you@example.com"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label htmlFor="login-password">Password</label>
        <input
          type="password"
          id="login-password"
          placeholder="••••••••"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <button className="auth-submit" type="submit" disabled={submitting}>
        {submitting ? 'Logging in…' : 'Log In'}
      </button>

      <p className="auth-switch">
        <a href="#reset" onClick={(e) => { e.preventDefault(); onSwitch('reset'); }}>
          Forgot your password?
        </a>
      </p>
      <p className="auth-switch">
        Don&apos;t have an account?{' '}
        <a href="#signup" onClick={(e) => { e.preventDefault(); onSwitch('signup'); }}>
          Sign up
        </a>
      </p>
    </form>
  );
}
